import { render, staticRenderFns } from "./RenovacioComponet.vue?vue&type=template&id=a2c2e0aa"
import script from "./RenovacioComponet.vue?vue&type=script&lang=js"
export * from "./RenovacioComponet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports